import React, { useState } from 'react';
import { Check, X, Heart, AlertCircle, ArrowRight, ShieldCheck, Clock, BookOpen, ShoppingBag, Calendar } from 'lucide-react';
import { FadeIn } from './components/FadeIn';
import { Accordion } from './components/Accordion';
import { Modal } from './components/Modal';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/rLvtVVBKEZVZp4ji9ZvLtk/Imagen_de_DIETA_21_D.png';
const CTAButton = ({
  className = '',
  onClick = () => {},
  checkout = false
}: {
  className?: string;
  onClick?: () => void;
  checkout?: boolean;
}) => <button onClick={() => {
  onClick();
  if (checkout) {
    window.location.href = 'https://www.claridadpluslab.com/cart/49039364194547:1';
  } else {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'auto',
        block: 'start'
      });
    }
  }
}} className={`group relative inline-flex items-center justify-center gap-3 bg-terracotta text-white px-8 py-4 rounded-full font-medium text-lg overflow-hidden transition-transform hover:scale-[1.02] active:scale-[0.98] shadow-lg shadow-terracotta/20 ${className}`} data-id="element-0">
    <span className="relative z-10" data-id="element-1">¡SÍ, QUIERO MI PROTOCOLO DE 21 DÍAS!</span>
    <ArrowRight className="relative z-10 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-2" />
    <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out rounded-full" data-id="element-3" />
  </button>;
export function App() {
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  return <div className="min-h-screen bg-cream overflow-x-hidden selection:bg-terracotta/20 selection:text-terracotta" data-id="element-4">
      {/* Announcement Bar */}
      <div className="bg-olive text-white text-sm py-2 text-center font-medium tracking-wide" data-id="element-5">
        <span className="flex items-center justify-center gap-2" data-id="element-6">
          <ShieldCheck size={16} data-id="element-7" /> Descarga inmediata · Pago seguro
        </span>
      </div>

      {/* HERO SECTION */}
      <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 px-6 overflow-hidden" data-id="element-8">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-30 pointer-events-none" data-id="element-9">
          <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-terracotta/10 blur-3xl" data-id="element-10" />
          <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-olive/10 blur-3xl" data-id="element-11" />
        </div>

        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-12">
          <FadeIn direction="right" className="max-w-xl" data-id="element-13">
            <div className="inline-block border border-terracotta/30 text-terracotta px-4 py-1.5 rounded-full text-sm font-medium mb-6 tracking-wide uppercase" data-id="element-14">
              Nuevo Lanzamiento
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl leading-[1.1] text-charcoal mb-6" data-id="element-15">
              El Protocolo de Ayuno Metabólico:{' '}
              <span className="text-terracotta italic" data-id="element-16">
                Recupera tu Figura en 21 Días
              </span>{' '}
              sin Renunciar al Sabor Latino
            </h1>
            <h2 className="text-lg md:text-xl text-charcoal/80 leading-relaxed mb-8 font-sans" data-id="element-17">
              Descubre el método de crono-nutrición diseñado para mujeres que
              quieren desinflamar su cuerpo y perder hasta 5kg sin vivir a base
              de lechuga.
            </h2>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 mb-8" data-id="element-18">
              <CTAButton data-id="element-19" />
            </div>

            <div className="flex items-center gap-4 text-sm text-charcoal/70 font-medium" data-id="element-20">
              <div className="flex -space-x-2" data-id="element-21">
                {['https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=100&h=100&fit=crop&crop=faces', 'https://images.unsplash.com/photo-1592621385612-4d7129426394?w=100&h=100&fit=crop&crop=faces', 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=100&h=100&fit=crop&crop=faces', 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&h=100&fit=crop&crop=faces'].map((src, i) => <div key={i} className="w-8 h-8 rounded-full border-2 border-cream bg-stone-200 overflow-hidden" data-id="element-22">
                    <img src={src} alt="Mujer latina" className="w-full h-full object-cover" data-id="element-23" />
                  </div>)}
              </div>
              <p data-id="element-24">Únete a +2,000 latinas transformando su cuerpo</p>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} className="relative" data-id="element-25">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl shadow-charcoal/10 transform md:rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-26">
              <img src={MOCKUP_URL} alt="El Protocolo de Ayuno Metabólico en iPad y iPhone" className="w-full h-auto object-cover" data-id="element-27" />
            </div>
            {/* Decorative elements behind mockup */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gold/20 rounded-full blur-2xl -z-10" data-id="element-28" />
            <div className="absolute -top-6 -left-6 w-40 h-40 bg-olive/20 rounded-full blur-2xl -z-10" data-id="element-29" />
          </FadeIn>
        </div>
      </section>

      {/* OPENING HOOK */}
      <section className="py-20 px-6 bg-white/50" data-id="element-30">
        <div className="max-w-3xl mx-auto text-center md:text-left" data-id="element-31">
          <FadeIn data-id="element-32">
            <p className="text-2xl md:text-3xl font-serif text-charcoal leading-relaxed mb-8" data-id="element-33">
              <span className="italic text-terracotta" data-id="element-34">
                Estás frente al espejo
              </span>
              , faltan pocos días para ese evento especial y el cierre del
              vestido simplemente no sube. Sientes esa pesadez en el abdomen que
              no desaparece ni dejando de desayunar.
            </p>
            <p className="text-lg text-charcoal/80 leading-relaxed" data-id="element-35">
              No es falta de voluntad. Es que tu metabolismo está bloqueado por
              un sistema de alimentación que no entiende tu cultura ni tu
              cuerpo.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* THE PROBLEM */}
      <section className="py-20 px-6" data-id="element-36">
        <div className="max-w-3xl mx-auto" data-id="element-37">
          <FadeIn data-id="element-38">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-8 text-center" data-id="element-39">
              El problema con las dietas tradicionales
            </h2>
            <div className="space-y-6 text-lg text-charcoal/80 leading-relaxed" data-id="element-40">
              <p data-id="element-41">
                La mayoría de las dietas fueron escritas para personas que no
                tocan un grano de arroz o un frijol. Te piden que comas
                alimentos insípidos que te dejan con hambre a las dos horas,
                provocando ansiedad y el inevitable efecto rebote.
              </p>
              <p data-id="element-42">
                Mientras sigas comiendo "sano" pero en los horarios incorrectos,
                tu insulina se mantendrá alta, enviando una señal a tu cuerpo
                para que almacene grasa en lugar de quemarla. Por eso, aunque te
                esfuerces, la balanza no se mueve.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* WHY WHAT YOU TRIED DIDN'T WORK */}
      <section className="py-20 px-6 bg-stone-100/50" data-id="element-43">
        <div className="max-w-4xl mx-auto" data-id="element-44">
          <FadeIn data-id="element-45">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-12 text-center" data-id="element-46">
              Por qué lo que has intentado no funcionó
            </h2>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-47">
              {['Las dietas de "solo ensalada" destruyen tu masa muscular y ralentizan tu metabolismo.', 'Contar calorías es una batalla perdida si tus hormonas del hambre están descontroladas.', 'Eliminar los carbohidratos latinos por completo genera una ansiedad que termina en atracones.', 'Los jugos "detox" solo te deshidratan, no eliminan la grasa acumulada en el abdomen.'].map((text, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-charcoal/5 flex gap-4 items-start" data-id="element-48">
                  <div className="bg-terracotta/10 p-2 rounded-full shrink-0 mt-1" data-id="element-49">
                    <X className="w-5 h-5 text-terracotta" data-id="element-50" />
                  </div>
                  <p className="text-charcoal/80 leading-relaxed" data-id="element-51">{text}</p>
                </div>)}
            </div>
          </FadeIn>
        </div>
      </section>

      {/* THE UNIQUE MECHANISM */}
      <section className="py-24 px-6 relative overflow-hidden" data-id="element-52">
        <div className="max-w-4xl mx-auto" data-id="element-53">
          <FadeIn className="bg-olive text-white rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-54">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" data-id="element-55" />
            <div className="relative z-10" data-id="element-56">
              <div className="inline-flex items-center gap-2 bg-white/20 px-4 py-1.5 rounded-full text-sm font-medium mb-8 backdrop-blur-sm" data-id="element-57">
                <Clock size={16} data-id="element-58" />
                El Secreto
              </div>
              <h2 className="text-3xl md:text-5xl font-serif mb-6 leading-tight" data-id="element-59">
                La Crono-Nutrición Latina
              </h2>
              <p className="text-lg md:text-xl text-white/90 leading-relaxed mb-8 max-w-2xl" data-id="element-60">
                No se trata de qué comes, sino de cuándo lo haces. Este
                protocolo utiliza ventanas de ayuno estratégico que le dan un
                descanso a tu sistema digestivo, permitiendo que tu cuerpo use
                su propia grasa como fuente de energía.
              </p>
              <p className="text-lg text-white/80 leading-relaxed max-w-2xl font-medium bg-black/10 p-6 rounded-2xl border border-white/10" data-id="element-61">
                Lo mejor: ajustamos tus platos típicos (arroz, granos, aguacate)
                para que trabajen a tu favor, no en tu contra.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* MID PAGE CTA */}
      <section className="py-12 px-6 text-center" data-id="element-62">
        <FadeIn data-id="element-63">
          <CTAButton data-id="element-64" />
        </FadeIn>
      </section>

      {/* WHAT YOU GET */}
      <section className="py-20 px-6 bg-white/50" data-id="element-65">
        <div className="max-w-5xl mx-auto" data-id="element-66">
          <FadeIn data-id="element-67">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-16 text-center" data-id="element-68">
              Lo que obtienes hoy
            </h2>

            <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-69">
              <div className="space-y-6" data-id="element-70">
                {[{
                icon: BookOpen,
                text: 'El Protocolo Maestro de 21 Días (Guía Paso a Paso).'
              }, {
                icon: Check,
                text: 'La Regla 80/20 para comer carbohidratos sin subir de peso.'
              }, {
                icon: Clock,
                text: 'Planificador de Ventanas Metabólicas (12:12 a 16:8).'
              }, {
                icon: ShoppingBag,
                text: 'Lista de compras inteligente para supermercados latinos.'
              }, {
                icon: Calendar,
                text: 'Guía de Supervivencia para Fiestas Familiares.'
              }].map((item, i) => <div key={i} className="flex items-center gap-4 bg-cream p-4 rounded-xl border border-olive/10 hover:border-olive/30 transition-colors" data-id="element-71">
                    <div className="bg-olive/10 p-3 rounded-full text-olive shrink-0" data-id="element-72">
                      <item.icon size={24} data-id="element-73" />
                    </div>
                    <p className="text-lg text-charcoal/90 font-medium" data-id="element-74">
                      {item.text}
                    </p>
                  </div>)}
              </div>

              <div className="relative hidden lg:block" data-id="element-75">
                <div className="absolute inset-0 bg-gradient-to-tr from-cream to-transparent rounded-3xl -z-10 transform translate-x-4 translate-y-4" data-id="element-76" />
                <img src={MOCKUP_URL} alt="Contenido del Protocolo" className="w-full h-auto object-cover rounded-3xl shadow-xl" data-id="element-77" />
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* WHO THIS IS FOR / NOT FOR */}
      <section className="py-24 px-6" data-id="element-78">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-79">
          <FadeIn direction="right" className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-olive" data-id="element-80">
            <div className="flex items-center gap-3 mb-8" data-id="element-81">
              <Heart className="text-olive w-8 h-8" data-id="element-82" />
              <h3 className="text-2xl font-serif text-charcoal" data-id="element-83">
                Esto es para ti si...
              </h3>
            </div>
            <ul className="space-y-6" data-id="element-84">
              {['Mujeres que se sienten constantemente inflamadas y pesadas.', 'Personas que han probado todas las dietas y siempre recuperan el peso.', 'Latinas que no quieren renunciar al sabor de su comida en casa.', 'Quienes tienen poco tiempo y necesitan un plan práctico y directo.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-85">
                  <Check className="w-6 h-6 text-olive shrink-0 mt-0.5" data-id="element-86" />
                  <span className="text-charcoal/80 leading-relaxed" data-id="element-87">
                    {text}
                  </span>
                </li>)}
            </ul>
          </FadeIn>

          <FadeIn direction="left" className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-terracotta" data-id="element-88">
            <div className="flex items-center gap-3 mb-8" data-id="element-89">
              <AlertCircle className="text-terracotta w-8 h-8" data-id="element-90" />
              <h3 className="text-2xl font-serif text-charcoal" data-id="element-91">
                Esto NO es para ti si...
              </h3>
            </div>
            <ul className="space-y-6" data-id="element-92">
              {['Personas que buscan "pastillas milagrosas" sin cambiar hábitos.', 'Quienes no están dispuestos a seguir instrucciones sencillas por 21 días.', 'Personas con condiciones médicas crónicas que no han consultado a su médico.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-93">
                  <X className="w-6 h-6 text-terracotta shrink-0 mt-0.5" data-id="element-94" />
                  <span className="text-charcoal/80 leading-relaxed" data-id="element-95">
                    {text}
                  </span>
                </li>)}
            </ul>
          </FadeIn>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="py-20 px-6 bg-stone-100/50" data-id="element-96">
        <div className="max-w-4xl mx-auto" data-id="element-97">
          <FadeIn data-id="element-98">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-16 text-center" data-id="element-99">
              ¿Cómo funciona?
            </h2>
            <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-100">
              {/* Connecting line for desktop */}
              <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-terracotta/20 -z-10" data-id="element-101" />

              {[{
              step: '01',
              text: 'Descarga el protocolo e identifica tu ventana de alimentación ideal.'
            }, {
              step: '02',
              text: 'Sigue el menú de 21 días utilizando los alimentos que ya tienes en tu cocina.'
            }, {
              step: '03',
              text: 'Observa cómo desaparece la inflamación y recuperas tu energía desde la primera semana.'
            }].map((item, i) => <div key={i} className="relative flex flex-col items-center text-center" data-id="element-102">
                  <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center text-3xl font-serif text-terracotta shadow-md mb-6 border-4 border-cream" data-id="element-103">
                    {item.step}
                  </div>
                  <p className="text-charcoal/80 leading-relaxed px-4" data-id="element-104">
                    {item.text}
                  </p>
                </div>)}
            </div>
          </FadeIn>
        </div>
      </section>

      {/* PROOF / BELIEVABILITY */}
      <section className="py-20 px-6" data-id="element-105">
        <div className="max-w-3xl mx-auto text-center" data-id="element-106">
          <FadeIn data-id="element-107">
            <div className="text-gold mb-6 flex justify-center gap-1" data-id="element-108">
              {[1, 2, 3, 4, 5].map(i => <svg key={i} className="w-8 h-8 fill-current" viewBox="0 0 24 24" data-id="element-109">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-110" />
                </svg>)}
            </div>
            <p className="text-2xl md:text-3xl font-serif text-charcoal leading-relaxed mb-6" data-id="element-111">
              "En solo 7 días, la mayoría de las usuarias reportan una reducción
              notable en la circunferencia de la cintura y el fin de los
              'ataques de hambre' nocturnos."
            </p>
            <p className="text-lg text-terracotta font-medium uppercase tracking-widest" data-id="element-112">
              No es magia, es biología aplicada a tu ritmo de vida.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 px-6 bg-white/30" data-id="element-113">
        <div className="max-w-4xl mx-auto" data-id="element-114">
          <FadeIn data-id="element-115">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-12 text-center" data-id="element-116">
              Preguntas Frecuentes
            </h2>
            <Accordion items={[{
            question: '¿Voy a pasar mucha hambre?',
            answer: 'No, aprenderás a comer saciado en las horas correctas. El objetivo es nutrir tu cuerpo, no matarlo de hambre.'
          }, {
            question: '¿Tengo que comprar suplementos caros?',
            answer: 'No, todo lo que necesitas está en el supermercado local. Nos basamos en comida real y accesible.'
          }, {
            question: '¿Puedo tomar café?',
            answer: 'Sí, el café negro es una pieza clave de este proceso y te ayudará durante tus ventanas de ayuno.'
          }, {
            question: '¿Es seguro para mí?',
            answer: 'Es un método basado en comida real y periodos de descanso natural para tu sistema digestivo.'
          }, {
            question: '¿Qué pasa si tengo una fiesta?',
            answer: 'El manual incluye una guía específica para eventos sociales para que disfrutes sin perder tu progreso.'
          }]} data-id="element-117" />
          </FadeIn>
        </div>
      </section>

      {/* OFFER + PRICE BLOCK */}
      <section id="oferta" className="py-24 px-6 relative scroll-mt-8" data-id="element-118">
        <div className="max-w-3xl mx-auto text-center" data-id="element-119">
          <FadeIn className="bg-white p-8 md:p-16 rounded-[2.5rem] shadow-2xl border border-charcoal/5 relative overflow-hidden" data-id="element-120">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-terracotta via-gold to-olive" data-id="element-121" />

            <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-122">
              Empieza tu transformación hoy
            </h2>
            <p className="text-lg text-charcoal/80 mb-10 max-w-xl mx-auto" data-id="element-123">
              Hoy puedes obtener el Protocolo de Ayuno Metabólico completo por
              una fracción de lo que cuesta una consulta nutricional. Recupera
              la confianza al vestirte.
            </p>

            <div className="mb-10" data-id="element-124">
              <div className="inline-flex items-center gap-2 bg-terracotta/10 text-terracotta text-xs md:text-sm font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-6" data-id="element-125">
                <Clock size={14} data-id="element-126" />
                Oferta por tiempo limitado
              </div>

              <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-127">
                <span className="text-2xl md:text-3xl text-charcoal/40 font-medium line-through decoration-2" data-id="element-128">
                  $19.00
                </span>
                <span className="bg-olive text-white text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full" data-id="element-129">
                  -63%
                </span>
              </div>

              <div data-id="element-130">
                <span className="text-6xl md:text-7xl font-serif text-terracotta font-bold tracking-tight" data-id="element-131">
                  $6
                  <span className="text-2xl md:text-3xl text-terracotta/70 ml-1" data-id="element-132">
                    .99
                  </span>
                </span>
                <span className="text-xl text-charcoal/50 ml-2 font-medium" data-id="element-133">
                  USD
                </span>
              </div>

              <p className="mt-4 text-sm text-charcoal/60 italic" data-id="element-134">
                Precio promocional por tiempo limitado.
              </p>
            </div>

            <CTAButton checkout className="w-full md:w-auto md:px-12 py-5 text-xl mb-6" data-id="element-135" />

            <div className="flex items-center justify-center gap-2 text-sm text-charcoal/60 font-medium" data-id="element-136">
              <ShieldCheck size={18} className="text-olive" data-id="element-137" />
              Pago 100% seguro y descarga inmediata
            </div>
          </FadeIn>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="border-t border-charcoal/10 py-10 px-6 text-center text-charcoal/50 text-sm" data-id="element-138">
        <div className="max-w-3xl mx-auto space-y-4" data-id="element-139">
          <p className="text-xs max-w-2xl mx-auto opacity-80" data-id="element-140">
            Este producto no sustituye el consejo médico profesional. Consulta a
            tu médico antes de iniciar cualquier programa de nutrición.
          </p>

          <div className="flex items-center justify-center gap-6 pt-2" data-id="element-141">
            <button onClick={() => setOpenModal('privacy')} className="hover:text-terracotta transition-colors font-medium underline-offset-4 hover:underline" data-id="element-142">
              Política de Privacidad
            </button>
            <span className="text-charcoal/20" data-id="element-143">·</span>
            <button onClick={() => setOpenModal('terms')} className="hover:text-terracotta transition-colors font-medium underline-offset-4 hover:underline" data-id="element-144">
              Términos y Condiciones
            </button>
          </div>

          <p className="pt-2" data-id="element-145">
            © {new Date().getFullYear()} El Protocolo de Ayuno Metabólico.
            Todos los derechos reservados.
          </p>
        </div>
      </footer>

      {/* PRIVACY MODAL */}
      <Modal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-146">
        <p className="text-sm text-charcoal/50 italic" data-id="element-147">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-148">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-149">
          Recopilamos la información que nos proporcionas directamente al
          realizar una compra, como tu nombre y dirección de correo electrónico.
          Esta información es necesaria para procesar tu pedido y entregarte el
          producto digital.
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-150">
          2. Uso de la Información
        </h3>
        <p data-id="element-151">
          Utilizamos tu información únicamente para procesar tu compra, enviarte
          el material adquirido y comunicarnos contigo respecto a tu pedido.
          Eventualmente podríamos enviarte contenido educativo relacionado, del
          cual puedes darte de baja en cualquier momento.
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-152">
          3. Protección de Datos
        </h3>
        <p data-id="element-153">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal. Los pagos son procesados a través de
          plataformas seguras y encriptadas. No almacenamos información de
          tarjetas de crédito en nuestros servidores.
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-154">4. Cookies</h3>
        <p data-id="element-155">
          Este sitio utiliza cookies para mejorar la experiencia de navegación y
          analizar el rendimiento del sitio. Puedes configurar tu navegador para
          rechazar cookies si lo prefieres.
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-156">
          5. Compartir Información
        </h3>
        <p data-id="element-157">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, salvo cuando sea necesario para procesar tu pago (por
          ejemplo, con procesadores de pago) o cuando la ley lo requiera.
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-158">
          6. Tus Derechos
        </h3>
        <p data-id="element-159">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. También puedes solicitar que dejemos de
          procesar tus datos para fines de marketing.
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-160">
          7. Cambios a esta Política
        </h3>
        <p data-id="element-161">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Los cambios entrarán en vigor desde el momento de
          su publicación en esta página.
        </p>
      </Modal>

      {/* TERMS MODAL */}
      <Modal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-162">
        <p className="text-sm text-charcoal/50 italic" data-id="element-163">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-164">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-165">
          Al adquirir El Protocolo de Ayuno Metabólico, aceptas los términos y
          condiciones aquí descritos. Si no estás de acuerdo con alguno de
          ellos, te pedimos abstenerte de realizar la compra.
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-166">
          2. Descripción del Producto
        </h3>
        <p data-id="element-167">
          El Protocolo de Ayuno Metabólico es un producto digital descargable
          que incluye una guía de 21 días, planificadores y material
          complementario. El acceso se otorga inmediatamente después de
          confirmar el pago.
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-168">
          3. Aviso Médico
        </h3>
        <p data-id="element-169">
          El contenido de este producto tiene fines exclusivamente educativos e
          informativos. No constituye consejo médico, diagnóstico ni
          tratamiento. Antes de iniciar cualquier programa de nutrición o ayuno,
          te recomendamos consultar con un profesional de la salud,
          especialmente si tienes condiciones médicas preexistentes, estás
          embarazada o en periodo de lactancia.
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-170">4. Resultados</h3>
        <p data-id="element-171">
          Los resultados pueden variar de una persona a otra dependiendo de
          factores individuales como el metabolismo, estilo de vida y nivel de
          compromiso. No garantizamos resultados específicos en pérdida de peso
          ni en otros aspectos de salud.
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-172">
          5. Propiedad Intelectual
        </h3>
        <p data-id="element-173">
          Todo el contenido del Protocolo está protegido por derechos de autor.
          Queda prohibida la reproducción, distribución, copia o reventa total o
          parcial del material sin autorización expresa por escrito.
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-174">6. Reembolsos</h3>
        <p data-id="element-175">
          Debido a la naturaleza digital del producto y el acceso inmediato al
          contenido, todas las ventas son finales. Te invitamos a revisar
          cuidadosamente la descripción del producto antes de realizar tu
          compra.
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-176">
          7. Limitación de Responsabilidad
        </h3>
        <p data-id="element-177">
          No nos hacemos responsables por daños directos, indirectos o
          consecuentes derivados del uso o mal uso del material. El usuario
          asume la responsabilidad total al aplicar las recomendaciones
          contenidas en el producto.
        </p>

        <h3 className="text-xl font-serif text-charcoal mt-6" data-id="element-178">
          8. Modificaciones
        </h3>
        <p data-id="element-179">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios serán efectivos al publicarse en esta página.
        </p>
      </Modal>
    </div>;
}